import { Brandfolder } from '@integration-frontends/integration/core/model';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const brandfolderAdapter = createEntityAdapter<Brandfolder>();

export const brandfolderSlice = createSlice({
  name: 'brandfolder',
  initialState: brandfolderAdapter.getInitialState(),
  reducers: {
    brandfoldersReceived: brandfolderAdapter.addMany,
  },
});
